import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import { moduleHead } from "../../../../../config/constant";
import { NavLink, Link } from "react-router-dom";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import clsx from "clsx";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy, details, onEdit,
        onDelete, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                loadMoreTask={() => loadMoreTask()}
                heads={moduleHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(moduleHead, 0) }} key={data.id}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Module List', 'view', 'Younote Admin') ?
                                                            <Link style={{ width: getColumnWidth(moduleHead, 0) }} to={`/younote-admin/security-setup/module-list/${data.id}/view`}
                                                                className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.PaddingRight50, classes.disBlock, classes.bold)}>
                                                                {data.module}
                                                            </Link> : <span style={{ width: getColumnWidth(moduleHead, 0) }}>{data.module}</span>
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Module List', 'view', 'Younote Admin') &&
                                                            <Link to={`/younote-admin/security-setup/module-list/${data.id}/view`}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Module List', 'edit', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Module List', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
        </>
    )
}